import { call, put, takeEvery } from 'redux-saga/effects';
import { getLeadCustomer, getLeadProfile } from '../../requests/get_lead_profile_request';
import { changeLeadCustomer } from '../../requests/change_lead_profile_request';
import { changeLeadCustomerRequestSuccess, changeLeadCustomerRequestFailure } from '../actions/change_lead_customer.actions';
import {
    CHANGE_LEADS_CUSTOMER_REQUEST,
    UPDATE_LEAD_CUSTOMER_DATE_REQUEST,
} from '../constants/get_lead_profile.constants';
import { message_success, message_error } from '../../../../../components/Message';
import { updateCustomerCollectionDate } from '../../requests/set_lead_valuation_request';
import { getLeadProfileRequestSuccess } from '../actions/get_lead_profile.actions';

function* changeLeadCustomerRequest({ _id, key, value }) {
    const { result, msg, error } = yield call(changeLeadCustomer, _id, key, value);
    if (result) {
        const get_lead_customer = yield call(getLeadCustomer, _id);
        yield put(changeLeadCustomerRequestSuccess(get_lead_customer.options));
        message_success('Customer info updated successfully!');
    } else {
        yield put(changeLeadCustomerRequestFailure(error));
        message_error(msg);
    }
}

function* updateLeadCustomerDateRequest({
    _id, customer_collection_date,
}) {
    const {
        result: resultUpdate, msg, error,
    } = yield call(updateCustomerCollectionDate, _id, customer_collection_date);

    if (resultUpdate) {
        const {
            result, options: leadData,
        } = yield call(getLeadProfile, _id);


        if (result) {
            yield put(changeLeadCustomerRequestSuccess({ customer_collection_date: leadData.customer_collection_date }));
            message_success('Customer info updated successfully!');
        }
    } else {
        yield put(changeLeadCustomerRequestFailure(error));
        message_error(msg);
    }
}

export default function* changeLeadCustomerSaga() {
    yield takeEvery(CHANGE_LEADS_CUSTOMER_REQUEST, changeLeadCustomerRequest);
    yield takeEvery(UPDATE_LEAD_CUSTOMER_DATE_REQUEST, updateLeadCustomerDateRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/change_lead_customer.saga.js